// extracted by mini-css-extract-plugin
export default {"links":"links-RvDyA","category":"category-2ZQlJ","title":"title-1XyjR","linkItem":"linkItem-2mr3H","newTagWrapper":"newTagWrapper-1mliW"};